import { Button, Card, Text, Modal, Checkbox } from "@shopify/polaris";
import { useState } from "react";
import { useLocation } from "react-router-dom";

const MSMF = ({handleBanner}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedFields, setSelectedFields] = useState({
    ageGroup: false,
    color: false,
    customLabels: false,
    gender: false,
    googleProductCategory: false,
    material: false,
    pattern: false,
    productCondition: false,
    seoDescription: false,
    seoTitle: false,
    size: false,
    sizeSystem: false,
    sizeType: false,
    unitPricingMeasure: false,
    unitPricingBaseMeasure: false
  });
  const location = useLocation();
  console.log("asdasdb", handleBanner)

  const handleChange = (field) => {
    setSelectedFields(prev => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  const handleSelectAll = () => {
    const allSelected = Object.values(selectedFields).every(value => value);
    const newValue = !allSelected;
    
    setSelectedFields(prev => {
      const updated = {};
      Object.keys(prev).forEach(key => {
        updated[key] = newValue;
      });
      return updated;
    });
  };

  const handleMetaFieldSync = async () => {
    setIsLoading(true);
    try {
      const urlParams = new URLSearchParams(location.search);
      const shop = urlParams.get("shop");

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/shopify/sync-google-merchant-metafields?shop=${shop}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ fields: selectedFields })
        }
      );
      
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      setIsOpen(false);
      handleBanner(true)
    } catch (error) {
      console.error("Error syncing metafields:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const modalMarkup = (
    <div style={{ width: '90%', maxWidth: '500px', margin: '0 auto' }}>
      <Modal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        title="Please Choose fields which needs to resync"
        primaryAction={{
          content: 'Yes, Sync From Shopify',
          onAction: handleMetaFieldSync,
          loading: isLoading
        }}
        secondaryActions={[
          {
            content: 'No, Not Needed',
            onAction: () => setIsOpen(false),
          },
        ]}
      >
        <Modal.Section>
          <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'flex-end' }}>
            <Checkbox
              label="Select All"
              checked={Object.values(selectedFields).every(value => value)}
              onChange={handleSelectAll}
            />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
            <Checkbox
              label="Age Group"
              checked={selectedFields.ageGroup}
              onChange={() => handleChange('ageGroup')}
            />
            <Checkbox
              label="Color"
              checked={selectedFields.color}
              onChange={() => handleChange('color')}
            />
            <Checkbox
              label="Custom Labels"
              checked={selectedFields.customLabels}
              onChange={() => handleChange('customLabels')}
            />
            <Checkbox
              label="Gender"
              checked={selectedFields.gender}
              onChange={() => handleChange('gender')}
            />
            <Checkbox
              label="Google Product Category"
              checked={selectedFields.googleProductCategory}
              onChange={() => handleChange('googleProductCategory')}
            />
            <Checkbox
              label="Material"
              checked={selectedFields.material}
              onChange={() => handleChange('material')}
            />
            <Checkbox
              label="Pattern"
              checked={selectedFields.pattern}
              onChange={() => handleChange('pattern')}
            />
            <Checkbox
              label="Product Condition"
              checked={selectedFields.productCondition}
              onChange={() => handleChange('productCondition')}
            />
            <Checkbox
              label="SEO Description"
              checked={selectedFields.seoDescription}
              onChange={() => handleChange('seoDescription')}
            />
            <Checkbox
              label="SEO Title"
              checked={selectedFields.seoTitle}
              onChange={() => handleChange('seoTitle')}
            />
            <Checkbox
              label="Size"
              checked={selectedFields.size}
              onChange={() => handleChange('size')}
            />
            <Checkbox
              label="Size System"
              checked={selectedFields.sizeSystem}
              onChange={() => handleChange('sizeSystem')}
            />
            <Checkbox
              label="Size Type"
              checked={selectedFields.sizeType}
              onChange={() => handleChange('sizeType')}
            />
            <Checkbox
              label="Unit Pricing Measure"
              checked={selectedFields.unitPricingMeasure}
              onChange={() => handleChange('unitPricingMeasure')}
            />
            <Checkbox
              label="Unit Pricing Base Measure"
              checked={selectedFields.unitPricingBaseMeasure}
              onChange={() => handleChange('unitPricingBaseMeasure')}
            />
          </div>
          <div style={{ marginTop: '20px', padding: '16px'}}>
            <Text variant="bodyMd" as="p">
              Are you sure you want to Sync selected meta fields from product's Meta fields? 
              <Text variant="bodyMd" as="span" fontWeight="bold"> Please Note: </Text>
              This will overwrite Meta Fields changes which you have made within our app except Custom Titles & Description.
            </Text>
          </div>
        </Modal.Section>
      </Modal>
    </div>
  );

  return (
    <Card>
      <Text variant="headingMd" as="h6">
        Manually Sync Meta Fields
      </Text>
      <div style={{ padding: "10px 0" }}>
        <Text variant="bodyMd" as="p">
          Unfortunately, whenever you update meta field values (like SEO Title,
          SEO Description, Custom Labels, Age Group, Gender, and others),
          Shopify does not notify us of the change. But you can sync them from
          here by pressing this button
        </Text>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "10px",
        }}
      >
        <Button
          variant="primary"
          onClick={() => setIsOpen(true)}
        >
          Re-Sync Meta Fields
        </Button>
      </div>
      {modalMarkup}
    </Card>
  );
};

export default MSMF;
